import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import './download.css';

// Components
import BackButton from '../components/buttons/BackButton';
import HeaderNoAuth from '../components/Header/HeaderNoAuth';
import Card from '../components/Card/Card';
import Button from '../components/buttons/Button';
import SectionHeader from '../components/SectionHeader/SectionHeader';

// Icons
import { Smartphone, Monitor, Apple, Download } from 'lucide-react';

function TelechargementPage() {
  const { isSubscribed, profile } = useAuth();
  const isAuthenticated = isSubscribed || profile;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleAppStoreClick = () => {
    window.open(
      'https://apps.apple.com/ch/app/voxia/id6749589800',
      '_blank',
      'noopener,noreferrer'
    );
  };

  const handleGooglePlayClick = () => {
    window.open(
      'https://play.google.com/store/apps/details?id=com.gbmmedical.voxia',
      '_blank',
      'noopener,noreferrer'
    );
  };

  const handleWindowsDownload = () => {
    window.open(
      'https://voxia.gbm-medical.ch/telechargements/voxia.exe',
      '_blank',
      'noopener,noreferrer'
    );
  };

  const handleMacDownload = () => {
    window.open(
      'https://voxia.gbm-medical.ch/telechargements/voxia.dmg',
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <div className="download-page">
      {!isAuthenticated && <HeaderNoAuth />}
      {!isAuthenticated && <BackButton to="/landing" />}
      {isAuthenticated && <BackButton to="/guide" />}

      <div className="settings-container">
        {/* Mobile App Section */}
        <Card className="card-large">
          <SectionHeader icon={Smartphone} title="Application mobile" />

          <div className="download-description">
            <p>
              Téléchargez l'application voxia sur votre smartphone :
            </p>
          </div>

          <div className="download-store-buttons">
            <Button
              onClick={handleAppStoreClick}
              icon={Apple}
              variant="primary"
              size="large"
            >
              App Store
            </Button>

            <Button
              onClick={handleGooglePlayClick}
              icon={Smartphone}
              variant="primary"
              size="large"
            >
              Google Play
            </Button>
          </div>
        </Card>

        {/* Desktop App Section */}
        <Card className="card-large">
          <SectionHeader icon={Monitor} title="Application desktop" />

          <div className="download-description">
            <p>
              Téléchargez la version desktop pour profiter des fonctionnalités avancées :
            </p>
            <ul>
              <li>Utilisation sans installation</li>
              <li>Raccourcis clavier pour une insertion rapide des rapports</li>
              <li>Dictée Live</li>
              <li>Compatible avec tous les modèles de dictaphones physiques</li>
            </ul>
          </div>

          <div className="download-desktop-buttons">
          

            <Button
              onClick={handleMacDownload}
              icon={Download}
              variant="primary"
              size="large"
            >
              Télécharger pour macOS
            </Button>

            <Button
              onClick={handleWindowsDownload}
              icon={Download}
              variant="primary"
              size="large"
            >
              Télécharger pour Windows
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default TelechargementPage;